var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.55176 3.11466L12.8851 6.448M5.33301 14L1.33301 14.6667L1.99967 10.6667L10.9423 1.724C11.1924 1.47404 11.5315 1.33362 11.885 1.33362C12.2386 1.33362 12.5776 1.47404 12.8277 1.724L14.2757 3.172C14.5256 3.42204 14.6661 3.76111 14.6661 4.11467C14.6661 4.46822 14.5256 4.8073 14.2757 5.05733L5.33301 14Z",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.24a5607c.svg";
export { ForwardRef as ReactComponent };